import { getHours, getMinutes } from "date-fns";

const parseTimeToNumbers = (timeString) => {
  const [hours, minutes] = timeString.split(':').map(Number);
  return { hours, minutes };
};

const compareTimes = (timeA, timeB) => {
  const a = parseTimeToNumbers(timeA);
  const b = parseTimeToNumbers(timeB);
  
  if (a.hours === b.hours) {
    return a.minutes - b.minutes;
  }
  return a.hours - b.hours;
};

const formatTimeFromDate = (dateString) => {
  const date = new Date(dateString);
  return `${getHours(date)}:${getMinutes(date)}`;
};

const getTimeFromSlot = (slot) => {
  if (typeof slot === 'string') return slot;
  return formatTimeFromDate(slot.starts_at);
};

export const sortSlotsByTime = (slots) => {
  return [...slots].sort((a, b) => {
    const timeA = getTimeFromSlot(a);
    const timeB = getTimeFromSlot(b);
    return compareTimes(timeA, timeB);
  });
};